import { ReactNode } from "react";

export default function Container({
  children,
  className,
}: {
  children?: ReactNode;
  className?: string;
}) {
  return (
    <div className={`container bg-background py-6 px-8 ${className}`}>
      {children}
    </div>
  );
}
